import axios from './configObra/config-obra'

const defaultRoute = '/statistics'

export default {
  getUsers: (empresa = null, filial = null) => {
    let data = []
    if (empresa && filial) {
      data = axios.get(
        `${defaultRoute}/users?empresa=${empresa}&filial=${filial}`
      )
    } else if (empresa) {
      data = axios.get(`${defaultRoute}/users?empresa=${empresa}`)
    } else {
      data = axios.get(`${defaultRoute}/users`)
    }
    return data
  },

  getSystems: (empresa = null, filial = null) => {
    let data = []
    if (empresa && filial) {
      data = axios.get(
        `${defaultRoute}/systems?empresa=${empresa}&filial=${filial}`
      )
    } else if (empresa) {
      data = axios.get(`${defaultRoute}/systems?empresa=${empresa}`)
    } else {
      data = axios.get(`${defaultRoute}/systems`)
    }
    return data
  },

  getUsersActive: (empresa = null, filial = null) => {
    let data = []
    if (empresa && filial) {
      data = axios.get(
        `${defaultRoute}/users-actives?empresa=${empresa}&filial=${filial}`
      )
    } else if (empresa) {
      data = axios.get(`${defaultRoute}/users-actives?empresa=${empresa}`)
    } else {
      data = axios.get(`${defaultRoute}/users-actives`)
    }
    return data
  },

  getRequests: async (empresa = null, filial = null, obra = null, range = null) => {
    let data

    data = await axios.get(
      `${defaultRoute}/requests`, {
        params: {
          empresa,
          filial,
          obra,
          range
        }
      }
    )
  
    return data
  },

  getUsersCompany: (empresa = null, filial = null) => {
    if (empresa && filial) {
      return axios.get(
        `${defaultRoute}/users-company?empresa=${empresa}&filial=${filial}`
      )
    } else if (empresa) {
      return axios.get(`${defaultRoute}/users-company?empresa=${empresa}`)
    } else {
      return axios.get(`${defaultRoute}/users-company`)
    }
  },

  getRequestsMonth: (empresa = null, filial = null) => {
    if (empresa && filial) {
      return axios.get(
        `${defaultRoute}/requests-month?empresa=${empresa}&filial=${filial}`
      )
    } else if (empresa) {
      return axios.get(`${defaultRoute}/requests-month?empresa=${empresa}`)
    } else {
      return axios.get(`${defaultRoute}/requests-month`)
    }
  },

  getInsumos: (empresa = null, filial = null) => {
    if (empresa && filial) {
      return axios.get(
        `${defaultRoute}/insumos?empresa=${empresa}&filial=${filial}`
      )
    } else if (empresa) {
      return axios.get(`${defaultRoute}/insumos?empresa=${empresa}`)
    } else {
      return axios.get(`${defaultRoute}/insumos`)
    }
  },

  getFilials: (empresa = null) => {
    if (empresa) {
      return axios.get(`${defaultRoute}/filials?empresa=${empresa}`)
    } else {
      return axios.get(`${defaultRoute}/filials`)
    }
  },

  getWorks: (empresa = null, filial = null) => {
    if (empresa && filial) {
      return axios.get(
        `${defaultRoute}/works?empresa=${empresa}&filial=${filial}`
      )
    } else if (empresa) {
      return axios.get(`${defaultRoute}/works?empresa=${empresa}`)
    } else if (filial) {
      return axios.get(`${defaultRoute}/works?filial=${filial}`)
    } else {
      return axios.get(`${defaultRoute}/works`)
    }
  },

  getMovements: async (obra = null, filial = null, dataInicio = null, dataFim = null) => {
    let data = await axios
      .get(`/estoque/calcula-estoque`, {
        params: {
          obra,
          filial,
          dataInicio,
          dataFim
        },
      })

    return data
  },

  getExits: async (obra = null, filial = null, dataInicio = null, dataFim = null) => {
    let data = await axios
      .get(`/requisicoes/take-exit`, {
        params: {
          obra,
          filial,
          dataInicio,
          dataFim
        },
      })

    return data
  },

  getStockPeriod: async (obra = null, filial = null, dataInicio = null, dataFim = null) => {
    let data = await axios.get(`/orders/stock-by-period`, {
      params: {
        obra,
        filial,
        dataInicio,
        dataFim,
      },
    })

    return data
  },
}
